document.addEventListener('DOMContentLoaded', function () {
  const productBig_splide = document.querySelector('#productBig_splide');
  const productBigThumbnail_splide = document.querySelector(
    '#productBigThumbnail_splide'
  );

  // Slider for Big Image PDP
  if (productBig_splide) {
    var main = new Splide('#productBig_splide', {
      type: 'fade',
      pagination: false,
      arrows: false,
      drag: false,
      mediaQuery: 'min',
      breakpoints: {
        1024: {
          destroy: true, 
        },
      },
    });
  }

  // Slider for PDP Thumbnail
  if (productBigThumbnail_splide) {
    var thumbnails = new Splide('#productBigThumbnail_splide', {
      rewind: false,
      pagination: false,
      arrows: false,
      isNavigation: true,
      drag: true,
      mediaQuery: 'min',
      breakpoints: {
        1024: {
          destroy: true, 
        },
      },
    });
  }

  if (productBigThumbnail_splide) {
    main.sync(thumbnails);
  }
  if (productBig_splide) {
    main.mount();
  }
  if (productBigThumbnail_splide) {
    thumbnails.mount();

    // Autoplay Video Upon Click on PDP Thumbnail
    thumbnails.on('click', function (e) {
      const deferredId = e.slide.dataset.deferredId;
      const deferredElement = document.getElementById(deferredId);

      if (deferredElement) deferredElement.loadContent(true);
    });
  }
});
